import firebase from 'firebase';

const UserModule = {
  actions: {
    // eslint-disable-next-line no-unused-vars
    CAN_ACCESS: (_context, _email) => new Promise((resolve) => {
      resolve(true);
    }),
    GET_USER_DATA: ({ commit }, userEmail) => new Promise((resolve, reject) => {
      const getUserDataIfExist = (querySnapshot) => {
        if (querySnapshot.empty) throw new Error('auth/user-not-found');

        const [document] = querySnapshot.docs;
        return {
          docId: document.ref.id,
          ...document.data(),
        };
      };

      const commitAndResolve = (user) => {
        commit('SET_USER', user);
        resolve(user);
      };

      firebase.firestore()
        .collection('users')
        .where('email', '==', userEmail)
        .get()
        .then(getUserDataIfExist)
        .then(commitAndResolve)
        .catch((error) => reject(error.code));
    }),
    DELETE_ACCOUNT: ({ rootState, commit }) => {
      const { user } = rootState;
      const { docId } = user;
      firebase.firestore()
        .doc(`users/${docId}`)
        .delete()
        .then(() => {
          firebase.auth().currentUser.delete()
            .then(() => {
              commit('RESET_USER');
              commit('SET_DRAFT', null);
              window.location.reload(true);
            });
        });
    },
  },
};

export default UserModule;
